import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@fortem-monorepo/js-utilities';
export const HeaderConfigBar = ({ className, children, sticky = false, noPadding = false, }) => {
    return (_jsx("div", { className: cn('relative flex max-w-full', 'border-b', 'bg-sidebar backdrop-blur-2xl', 'z-40', {
            ['py-2 px-container-x']: !noPadding,
            ['sticky top-0 mt-[1px]']: sticky,
        }, className), children: children }));
};
